/* eslint-disable react/jsx-props-no-spreading */
import { Col, Row, Form, Input, Button, Divider, Tag, InputNumber } from 'antd';
import { DeleteOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { ReactComponent as IconReloj } from 'assets/images/monitoreos/SIMAC_Icono_reloj.svg';
import PropTypes from 'prop-types';
import { validateFileList } from 'utils/form/validators';
import { Upload, Accordion, AddButton } from 'components';
import * as fieldMsgs from 'constants/formFieldsMessages';

const ServidoresPublicos = ({ form, isLoading }) => {
  const formComponent = ({ remove, name, disabled, isLastHallazgo, ...restField }) => (
    <div>
      <div className="formulario-hallazgos">
        <Row gutter={24}>
          <Col xs={11} className="formulario-hallazgos-tabla-header">
            Información del Servidor Público:
          </Col>
          <Col xs={8} className="formulario-hallazgos-tabla-header">
            Muestras de documentación aprobatoria:
          </Col>
          <Col xs={3} className="formulario-hallazgos-tabla-header">
            Firma digital:
          </Col>
          <Col xs={2} style={{ textAlign: 'center' }} className="formulario-hallazgos-tabla-header">
            Acciones
          </Col>
        </Row>
        <Row>
          <Col xs={11} className="hallazgos-detalle">
            <Row gutter={[7, 0]} className="row-formulario-nested">
              <Col span={12}>
                <Form.Item
                  className=""
                  name={[name, 'nombre']}
                  label="Nombre(s):"
                  rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                  <Input placeholder="Nombre" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className=""
                  name={[name, 'apPaterno']}
                  label="Primer apellido:"
                  rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                  <Input placeholder="Primer apellido" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[7, 0]} className="row-formulario-nested">
              <Col span={12}>
                <Form.Item className="" name={[name, 'apMaterno']} label="Segundo apellido:">
                  <Input placeholder="Segundo apellido" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className=""
                  name={[name, 'puesto']}
                  label="Puesto:"
                  rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                  <Input placeholder="Escribe..." />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[7, 0]} className="row-formulario-nested">
              <Col span={12}>
                <Form.Item
                  className=""
                  name={[name, 'claveElector']}
                  label="Clave de elector:"
                  rules={[
                    {
                      required: true,
                      message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED
                    },
                    {
                      pattern: '^([A-Za-z]{5,6}\\d{8}[H|M|X]\\d{3})$|^([0-9]{13})$',
                      message: 'Verifica el formato de la clave de elector'
                    }
                  ]}>
                  <Input placeholder="Escribe..." />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className=""
                  name={[name, 'dependencia']}
                  label="Dependencia:"
                  rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                  <Input placeholder="Escribe..." />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[7, 0]} className="row-formulario-nested">
              <Col span={24}>
                <Form.Item label="Horario:">
                  <div className="div-reloj-campo-completo">
                    <div>
                      <IconReloj className="reloj-icon-completo" />
                    </div>
                    <Form.Item name={[name, 'horarioHr']} className="item-duracion-evento">
                      <InputNumber
                        className="reloj-input-completo"
                        placeholder="00"
                        min={0}
                        max={24}
                        keyboard
                      />
                    </Form.Item>
                    <div className="div-p-time">
                      <p>hrs.</p>
                    </div>
                    <Form.Item name={[name, 'horarioMin']} className="item-duracion-evento">
                      <InputNumber
                        className="reloj-input-completo"
                        placeholder="00"
                        min={0}
                        max={60}
                        keyboard
                      />
                    </Form.Item>
                    <div className="div-p-time">
                      <p>min.</p>
                    </div>
                    <Form.Item name={[name, 'horarioSeg']} className="item-duracion-evento">
                      <InputNumber
                        className="reloj-input-completo"
                        placeholder="00"
                        min={0}
                        max={60}
                        keyboard
                      />
                    </Form.Item>
                    <div className="div-p-time">
                      <p>seg.</p>
                    </div>
                  </div>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[7, 0]} className="row-formulario-nested">
              <Col span={12}>
                <Form.Item
                  className=""
                  name={[name, 'nivelParticipacion']}
                  label="Nivel de participación:"
                  rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                  <Input placeholder="Escribe..." />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className=""
                  name={[name, 'transporte']}
                  label="Transporte:"
                  rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                  <Input placeholder="Escribe..." />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col xs={8}>
            <div className="hallazgos-imagenes">
              <span className="subtitulo-descripcion">Captura de 2 a 5 muestras.</span>
              <div className="hallazgos-imagenes-row">
                <Form.Item
                  {...restField}
                  required
                  name={[name, 'muestra_1']}
                  label="Muestra 1"
                  className="hallazgos-imagenes-muestra"
                  rules={[
                    {
                      validator: validateFileList
                    }
                  ]}>
                  <Upload disabled={isLoading} loading={isLoading} />
                </Form.Item>
                <Form.Item
                  required
                  {...restField}
                  name={[name, 'muestra_2']}
                  label="Muestra 2"
                  className="hallazgos-imagenes-muestra"
                  rules={[
                    {
                      validator: validateFileList
                    }
                  ]}>
                  <Upload disabled={isLoading} loading={isLoading} />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, 'muestra_3']}
                  label="Muestra 3"
                  className="hallazgos-imagenes-muestra">
                  <Upload disabled={isLoading} loading={isLoading} />
                </Form.Item>
              </div>
              <div className="hallazgos-imagenes-row">
                <Form.Item
                  {...restField}
                  name={[name, 'muestra_4']}
                  label="Muestra 4"
                  className="hallazgos-imagenes-muestra">
                  <Upload disabled={isLoading} loading={isLoading} />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, 'muestra_5']}
                  label="Muestra 5"
                  className="hallazgos-imagenes-muestra">
                  <Upload disabled={isLoading} loading={isLoading} />
                </Form.Item>
              </div>
            </div>
          </Col>
          <Col xs={3}>
            <Row>
              <div className="hallazgos-imagenes-row">
                <Form.Item
                  {...restField}
                  required
                  name={[name, 'firma']}
                  className="hallazgos-imagenes-muestra"
                  rules={[
                    {
                      validator: validateFileList
                    }
                  ]}>
                  <Upload disabled={isLoading} loading={isLoading} />
                </Form.Item>
              </div>
            </Row>
          </Col>
          <Col xs={2}>
            <div className="hallazgos-imagenes-acciones">
              <Button disabled={isLastHallazgo} style={{ height: '2em' }}>
                <DeleteOutlined onClick={() => remove(name)} />
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );

  return (
    <div className="modal-monitoreo-internet-hallazgos">
      <Row gutter={[24, 0]} className="row-formulario">
        <Col span={24} className="col-dos-instrucciones">
          <span className="instruction-span-purple" style={{ paddingLeft: '9px' }}>
            Agrega los registros necesarios.
          </span>
          <Tag
            className="instruction-span-pink"
            icon={<ExclamationCircleFilled style={{ fontSize: '10px' }} />}
            bordered={false}
            color="magenta"
            style={{ marginBottom: '6px', paddingLeft: '9px' }}>
            El registro de servidores públicos es opcional. Si realizas el registro completa todos
            los campos solicitados.
          </Tag>
        </Col>
      </Row>
      <Form layout="vertical" form={form}>
        <Form.List name="servidores" initialValue={[{}]}>
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name, ...restField }) => {
                  const isLastHallazgo = fields.length <= 1;

                  const servidorPublico = {
                    key: `servidor_${key}`,
                    label: `Servidor Público ${name + 1}`,
                    forceRender: true,
                    children: formComponent({
                      remove,
                      name,
                      isLastHallazgo,
                      ...restField
                    })
                  };
                  return (
                    <Accordion
                      key={key}
                      items={[servidorPublico]}
                      defaultActiveKey={['servidor_0']}
                    />
                  );
                })}
                <Divider />
                <div className="formulario-hallazgos-acciones">
                  <AddButton
                    onClick={() => {
                      add();
                    }}
                    style={{ marginRight: '1em' }}>
                    Agregar Nuevo
                  </AddButton>
                </div>
              </>
            );
          }}
        </Form.List>
      </Form>
    </div>
  );
};

ServidoresPublicos.propTypes = {
  form: PropTypes.shape({}).isRequired,
  isLoading: PropTypes.bool.isRequired
};

export default ServidoresPublicos;
